// extracted by mini-css-extract-plugin
module.exports = {"main":"JuceBuilder_main__7c_Pa"};